import React from 'react';
import { useTranslation } from 'react-i18next';
import { SourceDetails } from 'features/layout/types';
import { LOCAL_MUTE_ICONS } from 'features/local-mute/icons';
import {
  ClickCallback,
  useTileLocalMute,
} from 'features/streaming/components/controls/useTileLocalMute';

export const useHearEveryoneControl = (source: SourceDetails, clickCallback: ClickCallback) => {
  const { t } = useTranslation('room');
  const { available, isAnyMuteActive, hearEveryone } = useTileLocalMute(source);

  return {
    show: available && isAnyMuteActive,
    icon: LOCAL_MUTE_ICONS.hearEveryone,
    text: t('tooltips.hear_everyone'),
    onClick: (e: React.MouseEvent<HTMLButtonElement | HTMLLIElement, MouseEvent>) => {
      clickCallback?.(e);
      hearEveryone();
    },
  };
};
